<template>
    <div v-if="subscriptionData">
        <div class="row my-1">
            <div class="col-12 col-md-4">
                <div class="row">
                    <div class="col-6 d-block d-md-none">
<!--                        mobile subscription status-->
                        <span v-if="subscriptionData.declined" class="text-danger">
                            <small><font-awesome-icon icon="fa-minus-circle" class="text-danger"/></small>
                            <span class="text-danger">{{ $t('cdb.subscription.status.inquiryRejected') }}</span>
                        </span>
                        <span v-else>
                            <small v-if="subscriptionStatus.icon"><font-awesome-icon :icon="subscriptionStatus.icon" :class="subscriptionStatus.colorClass"/></small>
                            <span :class="subscriptionStatus.colorClass">{{ subscriptionStatus.statusLabel }}</span>
                        </span>
                    </div>
                </div>
                <b-img :src="headerData.vehicle.title_image.url" fluid/>
            </div>
            <div class="col-12 col-md-8 d-flex flex-column">
                <div class="row">
                    <div class="col-12 d-none d-md-block">
<!--                            tablet/desktop subscription status-->
                        <span v-if="subscriptionData.declined">
                            <small><font-awesome-icon icon="fa-minus-circle" class="text-muted"/></small>
                            <span class="text-danger">{{ $t('cdb.subscription.status.inquiryRejected') }}</span>
                        </span>
                        <span v-else>
                            <small v-if="subscriptionStatus.icon"><font-awesome-icon :icon="subscriptionStatus.icon" :class="subscriptionStatus.colorClass"/></small>
                            <span :class="subscriptionStatus.colorClass">{{ subscriptionStatus.statusLabel }}</span>
                        </span>
                    </div>
                    <div class="col-12 pt-3 pb-4">
                        <b-link :to="$getUrl(
                            'pdp',
                            {
                                slug: headerData.vehicle.slug,
                                productUuid: headerData.vehicle_uuid
                            }
                        )">
                            <h5>{{ headerData.vehicle.brand.title}} {{ headerData.vehicle.model.title }}</h5>
                        </b-link>
                    </div>
                    <div v-if="isMvs" class="col-12 mb-3">
                        <span class="badge badge-secondary">{{ headerData.tier_title }}</span>
                    </div>
                </div>
                <div class="row">
                    <data-entry-column :title="$t('cdb.subscriptions.order_number')" :value="headerData.order_number" :full-width="true"></data-entry-column>
                </div>
                <div class="row mt-3" v-if="toggled || !hasMultipleEntries">
                    <div class="col-12 d-flex justify-content-between flex-wrap">
                        <div @click.stop="addSsn" v-if="this.$root.whitelabel.isUs() && ssnRequested && !hasSsn">
                            <button type="submit" class="btn btn-primary block">
                                {{ $t('cdb.subscriptions.add_ssn') }}
                            </button>
                        </div>
                        <div @click.stop="initHelp">
                            <button type="submit" class="btn btn-secondary block">
                                {{ $t('cdb.subscriptions.help_and_support') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BModal, BLink, BImg } from 'bootstrap-vue'
import { EventBus } from '../../event-bus';
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import StatusMixin from "../../../mixins/StatusMixin.vue";

export default {
    name: 'SubscriptionEntryHeader',
    components: {
        DataEntryColumn,
        BImg,
        BModal, BLink
    },
    mixins: [ StatusMixin ],
    props: {
        toggled: {
            type: Boolean
        },
        hasMultipleEntries: {
            type: Boolean
        },
        headerData: {
            type: Object,
            required: true
        },
        subscriptionData: {
            type: Object,
            required: true
        }
    },
    methods: {
        initHelp(){
            EventBus.$emit('init-help-modal');
        },
        addSsn() {
            EventBus.$emit('init-ssn-modal', this.subscriptionData);
        }
    },
    computed: {
        subscriptionStatus() {
            return this.calculateSubscriptionStatus(this.subscriptionData)
        },
        ssnRequested() {
            if (this.subscriptionData.ssn_requested == true) {
                return true
            }
            return false
        },
        hasSsn() {
            if (this.subscriptionData.user_has_ssn == true) {
                return true
            }
            return false
        },
        isMvs() {
            if (this.headerData.type == 'MVS') {
                return true
            }
            return false
        }
    }
}
</script>
